module.exports = __webpack_public_path__ + "media/interview_etiquette/test-your-knowledge_title-1daf2b45.png";